var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIndicatorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.14286C0 4.51168 0.447715 4 1 4H23C23.5523 4 24 4.51167 24 5.14286V18.8571C24 19.4883 23.5523 20 23 20H1C0.447716 20 0 19.4883 0 18.8571V5.14286Z",
    fill: "#74797D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 8.25C2 7.55964 2.49746 7 3.11111 7H20.8889C21.5025 7 22 7.55964 22 8.25V15.75C22 16.4404 21.5025 17 20.8889 17H3.11111C2.49746 17 2 16.4404 2 15.75V8.25Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 10H6.54326C6.81319 10 7.05964 10.042 7.28262 10.1261C7.5056 10.2101 7.69533 10.3362 7.85181 10.5043C8.00829 10.6686 8.12956 10.8768 8.21562 11.1289C8.30169 11.3773 8.34472 11.6676 8.34472 12C8.34472 12.3324 8.30169 12.6246 8.21562 12.8768C8.12956 13.1251 8.00829 13.3333 7.85181 13.5014C7.69533 13.6657 7.5056 13.7899 7.28262 13.8739C7.05964 13.958 6.81319 14 6.54326 14H5V10ZM6.54326 13.2264C6.80928 13.2264 7.01857 13.1538 7.17113 13.0086C7.3237 12.8634 7.39998 12.6304 7.39998 12.3095V11.6905C7.39998 11.3696 7.3237 11.1366 7.17113 10.9914C7.01857 10.8462 6.80928 10.7736 6.54326 10.7736H5.89192V13.2264H6.54326Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.397 14L11.1036 13.0487H9.73633L9.44294 14H8.53928L9.8889 10H10.9921L12.3241 14H11.397ZM10.4287 10.7908H10.3994L9.94758 12.3095H10.8864L10.4287 10.7908Z",
    fill: "#333333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2144 10.7736V14H13.3225V10.7736H12.2134V10H15.3234V10.7736H14.2144Z",
    fill: "#333333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0729 14L17.7795 13.0487H16.4122L16.1188 14H15.2152L16.5648 10H17.668L19 14H18.0729ZM17.1047 10.7908H17.0753L16.6235 12.3095H17.5624L17.1047 10.7908Z",
    fill: "#333333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndicatorIcon);
export default __webpack_public_path__ + "static/media/indicator-icon.f061d3405ebc39a82799c5db8ee29940.svg";
export { ForwardRef as ReactComponent };